import { H as be } from "./index.esm-BnYHxCYC.js";
import { z as je, M as rt, J as nt, u as ot } from "./useExposedProps-B8NHdNRq.js";
import { b2 as Ee, ac as st, L as re, c as Se, O as at } from "./chunk-PVWAREVJ-BO6B-RAk.js";
import { u as it, a as z } from "./hook-BkLXq8pm.js";
import { Button as ct } from "./ui/Button.js";
import { Callout as lt } from "./ui/Callout.js";
import { C as F } from "./ClientOnly-E7hGysn1.js";
import { j as q, d as O, m as we, o as ut, p as dt, b as ft, N as mt, Z as ht, g as pt, e as gt, C as vt } from "./ZudokuContext-BcqSiygJ.js";
import { E as xt, a as R, d as yt, b as bt, c as jt, V as Et, M as St, T as wt } from "./ErrorAlert-xpVkFS_n.js";
import { S as Ct } from "./Spinner-Cf6E803I.js";
import { j as r } from "./jsx-runtime-DywqP_6a.js";
import { Component as Pt, createElement as ie, createContext as ne, useState as L, useRef as D, useCallback as M, useEffect as $, Suspense as Ce, memo as Pe, useMemo as W, useContext as Nt } from "react";
import { isNavigationPlugin as ce, isAuthenticationPlugin as Tt, isEventConsumerPlugin as _t, needsInitialization as Mt, isApiIdentityPlugin as At, isProfileMenuPlugin as Ne, isSearchPlugin as Rt, isMdxProviderPlugin as kt, hasHead as Ot } from "./zudoku.plugins.js";
import { B as J } from "./Button-DTDRi4CT.js";
import { c as k } from "./cn-dYga0KKN.js";
import { DropdownMenu as $t, DropdownMenuTrigger as It, DropdownMenuContent as Dt, DropdownMenuLabel as Ft, DropdownMenuSeparator as X, DropdownMenuSub as Lt, DropdownMenuSubTrigger as zt, DropdownMenuPortal as qt, DropdownMenuSubContent as Bt, DropdownMenuItem as Yt } from "./ui/DropdownMenu.js";
import { CircleXIcon as Zt, ChevronRightIcon as Ht, SearchIcon as Kt, SunIcon as Ut, MoonIcon as Vt, MenuIcon as Wt } from "lucide-react";
import { VisuallyHidden as Xt } from "@radix-ui/react-visually-hidden";
import { D as Gt, a as Qt, b as Jt, c as er } from "./Drawer-DM9wJUC6.js";
import { a as tr } from "./index-DI5SPFK9.js";
const rr = ne(null), G = {
  didCatch: !1,
  error: null
};
class nr extends Pt {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = G;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var n, o, i = arguments.length, c = new Array(i), s = 0; s < i; s++)
        c[s] = arguments[s];
      (n = (o = this.props).onReset) === null || n === void 0 || n.call(o, {
        args: c,
        reason: "imperative-api"
      }), this.setState(G);
    }
  }
  componentDidCatch(t, n) {
    var o, i;
    (o = (i = this.props).onError) === null || o === void 0 || o.call(i, t, n);
  }
  componentDidUpdate(t, n) {
    const {
      didCatch: o
    } = this.state, {
      resetKeys: i
    } = this.props;
    if (o && n.error !== null && or(t.resetKeys, i)) {
      var c, s;
      (c = (s = this.props).onReset) === null || c === void 0 || c.call(s, {
        next: i,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(G);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: n,
      FallbackComponent: o,
      fallback: i
    } = this.props, {
      didCatch: c,
      error: s
    } = this.state;
    let d = t;
    if (c) {
      const v = {
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof n == "function")
        d = n(v);
      else if (o)
        d = ie(o, v);
      else if (i !== void 0)
        d = i;
      else
        throw s;
    }
    return ie(rr.Provider, {
      value: {
        didCatch: c,
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, d);
  }
}
function or() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((n, o) => !Object.is(n, t[o]));
}
let sr = () => ({
  emit(e, ...t) {
    for (let n = this.events[e] || [], o = 0, i = n.length; o < i; o++)
      n[o](...t);
  },
  events: {},
  on(e, t) {
    return (this.events[e] ||= []).push(t), () => {
      this.events[e] = this.events[e]?.filter((n) => t !== n);
    };
  }
});
const ar = (e) => Object.entries(e), le = (e) => {
  if (e)
    return Array.isArray(e) ? Object.fromEntries(
      e.map((t) => [
        t,
        (n) => n.auth.isAuthenticated
      ])
    ) : e;
};
class ir {
  plugins;
  navigation;
  meta;
  site;
  authentication;
  queryClient;
  options;
  navigationPlugins;
  emitter = sr();
  constructor(t, n) {
    const i = {
      ...Object.fromEntries(
        (t.plugins ?? []).flatMap((c) => {
          if (!ce(c)) return [];
          const s = c.getProtectedRoutes?.();
          return s ? Object.entries(le(s) ?? {}) : [];
        })
      ),
      ...le(t.protectedRoutes)
    };
    this.queryClient = n, this.options = { ...t, protectedRoutes: i }, this.plugins = t.plugins ?? [], this.navigation = t.navigation ?? [], this.navigationPlugins = this.plugins.filter(ce), this.authentication = this.plugins.find(Tt), this.meta = t.metadata, this.site = t.site, this.plugins.forEach((c) => {
      _t(c) && ar(c.events).forEach(([s, d]) => {
        this.emitter.on(s, d);
      });
    }), it.subscribe((c, s) => {
      this.emitEvent("auth", {
        prev: s,
        next: c
      });
    });
  }
  initialize = async () => {
    await Promise.all(
      this.plugins.filter(Mt).map((t) => t.initialize?.(this))
    );
  };
  getApiIdentities = async () => (await Promise.all(
    this.plugins.filter(At).map((n) => n.getIdentities(this))
  )).flat();
  addEventListener(t, n) {
    return this.emitter.on(t, n);
  }
  emitEvent = (t, ...n) => this.emitter.emit(t, ...n);
  getPluginNavigation = async (t) => (await Promise.all(
    this.navigationPlugins.map(
      (o) => o.getNavigation?.(q(t), this)
    )
  )).flatMap((o) => o ?? []);
  getProfileMenuItems = () => this.plugins.filter((n) => Ne(n)).flatMap((n) => n.getProfileMenuItems(this)).sort(cr(["top", "middle", "bottom"])).sort((n) => n.weight ?? 0);
  signRequest = async (t) => {
    if (!this.authentication)
      throw new Error("No authentication provider configured");
    return await this.authentication.signRequest(t);
  };
}
const cr = (e) => (t, n) => {
  const o = e.indexOf(t.category ?? "middle"), i = e.indexOf(n.category ?? "middle");
  return o - i;
};
function lr({ error: e }) {
  return /* @__PURE__ */ r.jsx(xt, { error: e });
}
const ue = ne({ stagger: !1 }), Y = globalThis;
(!Y.requestIdleCallback || !Y.cancelIdleCallback) && (Y.requestIdleCallback = (e) => setTimeout(e, 1), Y.cancelIdleCallback = clearTimeout);
function ee({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      className: k("animate-pulse rounded-md bg-muted", e),
      ...t
    }
  );
}
const de = {
  info: "bg-blue-500",
  note: "bg-gray-500",
  tip: "bg-green-600",
  caution: "bg-orange-500",
  danger: "bg-rose-500"
}, ur = () => {
  const { site: e } = O(), [t, n] = L(!0);
  if (!e?.banner || !t)
    return /* @__PURE__ */ r.jsx("style", { children: ":root { --banner-height: 0px; }" });
  const o = e.banner.color && e.banner.color in de ? de[e.banner.color] : e.banner.color ? void 0 : "bg-primary", i = o ? {} : { backgroundColor: e.banner.color };
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: k(
        "relative text-primary-foreground text-sm font-medium px-4 py-2 flex gap-2 items-center lg:h-(--banner-height)",
        o
      ),
      style: i,
      children: [
        /* @__PURE__ */ r.jsx("div", { className: "w-full", children: e.banner.message }),
        e.banner.dismissible && /* @__PURE__ */ r.jsx(
          "button",
          {
            type: "button",
            className: "md:absolute md:end-4 -m-1.5 p-1.5 hover:bg-accent-foreground/10 rounded-md",
            onClick: () => n(!1),
            children: /* @__PURE__ */ r.jsx(Zt, { size: 16 })
          }
        )
      ]
    }
  );
}, Te = (e) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132 100",
    fill: "none",
    ...e,
    children: [
      /* @__PURE__ */ r.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M80.092 2.963A4.66 4.66 0 0 1 84.449 0h34.049c6.325 0 10.835 6.135 8.948 12.172L116.653 46.71a4.688 4.688 0 0 1-4.474 3.29H75c-5.178 0-7.813 4.687-9.375 9.374-1.288 3.864-11.07 28.963-14.467 37.662A4.66 4.66 0 0 1 46.801 100H12.75c-6.324 0-10.834-6.134-8.947-12.171l10.793-34.54A4.688 4.688 0 0 1 19.071 50H56.25c5.178 0 7.813-4.687 9.375-9.375 1.288-3.864 11.07-28.962 14.467-37.662Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M83.54 57.813a7.813 7.813 0 0 0-7.316 5.07L63.888 95.777c-.766 2.043.744 4.222 2.926 4.222h36.828c5.211 0 9.875-3.232 11.704-8.11l8.821-23.522c1.915-5.107-1.861-10.555-7.315-10.555H83.539ZM29.17 0a12.5 12.5 0 0 0-11.704 8.111l-8.82 23.521c-1.915 5.107 1.86 10.556 7.315 10.556h33.312a7.813 7.813 0 0 0 7.316-5.07L68.924 4.223C69.691 2.18 68.18 0 65.998 0H29.17Z"
        }
      )
    ]
  }
);
Te.displayName = "ZudokuLogo";
const dr = ({ className: e }) => /* @__PURE__ */ r.jsxs(
  "a",
  {
    href: "https://zudoku.dev",
    target: "_blank",
    rel: "noopener noreferrer",
    className: k(
      "flex justify-between items-center w-full border border-transparent hover:border-border rounded-full hover:shadow-xs h-7 px-3 text-nowrap hover:bg-muted/80 transition-all",
      e
    ),
    children: [
      /* @__PURE__ */ r.jsxs("div", { className: "opacity-70 hover:opacity-100 transition-opacity gap-1.5 text-[11px] font-medium rounded-full h-7 flex items-center text-nowrap", children: [
        /* @__PURE__ */ r.jsx(Te, { className: "w-3.5 h-3.5 dark:fill-white" }),
        "powered by ",
        "Zudoku"
      ] }),
      /* @__PURE__ */ r.jsx("div", { className: "text-xs font-medium opacity-70 hover:text-foreground transition-colors cursor-pointer", children: /* @__PURE__ */ r.jsx(
        Ht,
        {
          size: 12,
          absoluteStrokeWidth: !0,
          strokeWidth: 1.5,
          className: "rtl:rotate-180"
        }
      ) })
    ]
  }
);
function K() {
  return K = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) ({}).hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, K.apply(null, arguments);
}
var Z = { exports: {} }, h = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fe;
function fr() {
  if (fe) return h;
  fe = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, c = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, d = e ? Symbol.for("react.context") : 60110, v = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, l = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, S = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, P = e ? Symbol.for("react.scope") : 60119;
  function j(a) {
    if (typeof a == "object" && a !== null) {
      var x = a.$$typeof;
      switch (x) {
        case t:
          switch (a = a.type, a) {
            case v:
            case f:
            case o:
            case c:
            case i:
            case y:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case d:
                case b:
                case g:
                case l:
                case s:
                  return a;
                default:
                  return x;
              }
          }
        case n:
          return x;
      }
    }
  }
  function E(a) {
    return j(a) === f;
  }
  return h.AsyncMode = v, h.ConcurrentMode = f, h.ContextConsumer = d, h.ContextProvider = s, h.Element = t, h.ForwardRef = b, h.Fragment = o, h.Lazy = g, h.Memo = l, h.Portal = n, h.Profiler = c, h.StrictMode = i, h.Suspense = y, h.isAsyncMode = function(a) {
    return E(a) || j(a) === v;
  }, h.isConcurrentMode = E, h.isContextConsumer = function(a) {
    return j(a) === d;
  }, h.isContextProvider = function(a) {
    return j(a) === s;
  }, h.isElement = function(a) {
    return typeof a == "object" && a !== null && a.$$typeof === t;
  }, h.isForwardRef = function(a) {
    return j(a) === b;
  }, h.isFragment = function(a) {
    return j(a) === o;
  }, h.isLazy = function(a) {
    return j(a) === g;
  }, h.isMemo = function(a) {
    return j(a) === l;
  }, h.isPortal = function(a) {
    return j(a) === n;
  }, h.isProfiler = function(a) {
    return j(a) === c;
  }, h.isStrictMode = function(a) {
    return j(a) === i;
  }, h.isSuspense = function(a) {
    return j(a) === y;
  }, h.isValidElementType = function(a) {
    return typeof a == "string" || typeof a == "function" || a === o || a === f || a === c || a === i || a === y || a === m || typeof a == "object" && a !== null && (a.$$typeof === g || a.$$typeof === l || a.$$typeof === s || a.$$typeof === d || a.$$typeof === b || a.$$typeof === w || a.$$typeof === C || a.$$typeof === P || a.$$typeof === S);
  }, h.typeOf = j, h;
}
var p = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var me;
function mr() {
  return me || (me = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, c = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, d = e ? Symbol.for("react.context") : 60110, v = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, l = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, S = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, P = e ? Symbol.for("react.scope") : 60119;
    function j(u) {
      return typeof u == "string" || typeof u == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      u === o || u === f || u === c || u === i || u === y || u === m || typeof u == "object" && u !== null && (u.$$typeof === g || u.$$typeof === l || u.$$typeof === s || u.$$typeof === d || u.$$typeof === b || u.$$typeof === w || u.$$typeof === C || u.$$typeof === P || u.$$typeof === S);
    }
    function E(u) {
      if (typeof u == "object" && u !== null) {
        var V = u.$$typeof;
        switch (V) {
          case t:
            var B = u.type;
            switch (B) {
              case v:
              case f:
              case o:
              case c:
              case i:
              case y:
                return B;
              default:
                var ae = B && B.$$typeof;
                switch (ae) {
                  case d:
                  case b:
                  case g:
                  case l:
                  case s:
                    return ae;
                  default:
                    return V;
                }
            }
          case n:
            return V;
        }
      }
    }
    var a = v, x = f, N = d, T = s, I = t, _ = b, U = o, A = g, Le = l, ze = n, qe = c, Be = i, Ye = y, oe = !1;
    function Ze(u) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), se(u) || E(u) === v;
    }
    function se(u) {
      return E(u) === f;
    }
    function He(u) {
      return E(u) === d;
    }
    function Ke(u) {
      return E(u) === s;
    }
    function Ue(u) {
      return typeof u == "object" && u !== null && u.$$typeof === t;
    }
    function Ve(u) {
      return E(u) === b;
    }
    function We(u) {
      return E(u) === o;
    }
    function Xe(u) {
      return E(u) === g;
    }
    function Ge(u) {
      return E(u) === l;
    }
    function Qe(u) {
      return E(u) === n;
    }
    function Je(u) {
      return E(u) === c;
    }
    function et(u) {
      return E(u) === i;
    }
    function tt(u) {
      return E(u) === y;
    }
    p.AsyncMode = a, p.ConcurrentMode = x, p.ContextConsumer = N, p.ContextProvider = T, p.Element = I, p.ForwardRef = _, p.Fragment = U, p.Lazy = A, p.Memo = Le, p.Portal = ze, p.Profiler = qe, p.StrictMode = Be, p.Suspense = Ye, p.isAsyncMode = Ze, p.isConcurrentMode = se, p.isContextConsumer = He, p.isContextProvider = Ke, p.isElement = Ue, p.isForwardRef = Ve, p.isFragment = We, p.isLazy = Xe, p.isMemo = Ge, p.isPortal = Qe, p.isProfiler = Je, p.isStrictMode = et, p.isSuspense = tt, p.isValidElementType = j, p.typeOf = E;
  }()), p;
}
var he;
function hr() {
  return he || (he = 1, process.env.NODE_ENV === "production" ? Z.exports = fr() : Z.exports = mr()), Z.exports;
}
var Q, pe;
function pr() {
  if (pe) return Q;
  pe = 1;
  var e = hr(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, o = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, i = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, c = {};
  c[e.ForwardRef] = o, c[e.Memo] = i;
  function s(g) {
    return e.isMemo(g) ? i : c[g.$$typeof] || t;
  }
  var d = Object.defineProperty, v = Object.getOwnPropertyNames, f = Object.getOwnPropertySymbols, b = Object.getOwnPropertyDescriptor, y = Object.getPrototypeOf, m = Object.prototype;
  function l(g, S, w) {
    if (typeof S != "string") {
      if (m) {
        var C = y(S);
        C && C !== m && l(g, C, w);
      }
      var P = v(S);
      f && (P = P.concat(f(S)));
      for (var j = s(g), E = s(S), a = 0; a < P.length; ++a) {
        var x = P[a];
        if (!n[x] && !(w && w[x]) && !(E && E[x]) && !(j && j[x])) {
          var N = b(S, x);
          try {
            d(g, x, N);
          } catch {
          }
        }
      }
    }
    return g;
  }
  return Q = l, Q;
}
pr();
var _e = function(t, n, o) {
  return t = t <= o ? t : o, t = t >= n ? t : n, t;
}, gr = function() {
  var t = !1, n = [], o = function() {
    t = !0;
    var d = n.shift();
    if (d)
      return d(o);
    t = !1;
  }, i = function() {
    t = !1, n = [];
  }, c = function(d) {
    n.push(d), !t && n.length === 1 && o();
  };
  return {
    clear: i,
    enqueue: c
  };
}, vr = function() {
  var t, n = function() {
    t && window.cancelAnimationFrame(t);
  }, o = function(c, s) {
    var d, v, f = function(y) {
      if (v = v || y, d = y - v, d > s) {
        c();
        return;
      }
      t = window.requestAnimationFrame(f);
    };
    t = window.requestAnimationFrame(f);
  };
  return {
    cancel: n,
    schedule: o
  };
}, xr = function(t) {
  var n = 0;
  return t >= 0 && t < 0.2 ? n = 0.1 : t >= 0.2 && t < 0.5 ? n = 0.04 : t >= 0.5 && t < 0.8 ? n = 0.02 : t >= 0.8 && t < 0.99 && (n = 5e-3), _e(t + n, 0, 0.994);
}, ge = function(t) {
  $(t, []);
}, yr = function(t) {
  return ++t % 1e6;
}, br = function() {
  var t = L(0), n = t[1];
  return M(function() {
    return n(yr);
  }, []);
}, jr = function(t) {
  t === void 0 && (t = {});
  var n = br(), o = D(K({}, t)), i = M(function() {
    return o.current;
  }, []), c = M(function(s) {
    s && (Object.assign(o.current, s), n());
  }, []);
  return [i, c];
}, Er = function() {
  var t = D(!0);
  return t.current ? (t.current = !1, !0) : t.current;
}, ve = function(t, n) {
  var o = Er();
  $(function() {
    if (!o)
      return t();
  }, n);
}, Me = function() {
}, xe = {
  isFinished: !0,
  progress: 0,
  sideEffect: Me
}, Sr = function(t) {
  var n = t === void 0 ? {} : t, o = n.animationDuration, i = o === void 0 ? 200 : o, c = n.incrementDuration, s = c === void 0 ? 800 : c, d = n.isAnimating, v = d === void 0 ? !1 : d, f = n.minimum, b = f === void 0 ? 0.08 : f, y = jr(xe), m = y[0], l = y[1], g = D(null), S = D(null);
  ge(function() {
    g.current = gr(), S.current = vr();
  });
  var w = M(function() {
    var x, N;
    (x = S.current) == null || x.cancel(), (N = g.current) == null || N.clear();
  }, []), C = M(function(x) {
    var N;
    if (x = _e(x, b, 1), x === 1) {
      var T, I;
      w(), (T = g.current) == null || T.enqueue(function(_) {
        l({
          progress: x,
          sideEffect: function() {
            var A;
            return (A = S.current) == null ? void 0 : A.schedule(_, i);
          }
        });
      }), (I = g.current) == null || I.enqueue(function() {
        l({
          isFinished: !0,
          sideEffect: w
        });
      });
      return;
    }
    (N = g.current) == null || N.enqueue(function(_) {
      l({
        isFinished: !1,
        progress: x,
        sideEffect: function() {
          var A;
          return (A = S.current) == null ? void 0 : A.schedule(_, i);
        }
      });
    });
  }, [i, w, b, g, l, S]), P = M(function() {
    C(xr(m().progress));
  }, [m, C]), j = M(function() {
    var x = function() {
      var T;
      P(), (T = g.current) == null || T.enqueue(function(I) {
        var _;
        (_ = S.current) == null || _.schedule(function() {
          x(), I();
        }, s);
      });
    };
    x();
  }, [s, g, S, P]), E = D(Me), a = m().sideEffect;
  return $(function() {
    E.current = P;
  }), ge(function() {
    return v && j(), w;
  }), ve(function() {
    m().sideEffect();
  }, [m, a]), ve(function() {
    v ? l(K({}, xe, {
      sideEffect: j
    })) : C(1);
  }, [v, C, l, j]), {
    animationDuration: i,
    isFinished: m().isFinished,
    progress: m().progress
  };
};
const Ae = () => {
  const t = Ee().state === "loading", [n, o] = L(!1);
  $(() => {
    const s = setTimeout(() => o(t), 200);
    return () => clearTimeout(s);
  }, [t]);
  const { isFinished: i, progress: c } = Sr({ isAnimating: n });
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      className: "absolute w-0 left-0 right-0 bottom-[-1px] h-[2px] bg-primary transition-all duration-300 ease-in-out",
      style: {
        opacity: i ? 0 : 1,
        width: i ? 0 : `${c * 100}%`
      }
    }
  );
};
function wr() {
  const e = navigator.userAgent.toLowerCase();
  if (e.includes("win")) return "Windows";
  if (e.includes("mac")) return "macOS";
  if (e.includes("linux")) return "Linux";
}
const Re = ({ className: e }) => {
  const t = O(), [n, o] = L(!1), i = M(() => o(!1), []);
  $(() => {
    if (n)
      return;
    function s(d) {
      d.key === "k" && (d.metaKey || d.ctrlKey) && (d.preventDefault(), o(!0));
    }
    return window.addEventListener("keydown", s), () => {
      window.removeEventListener("keydown", s);
    };
  }, [n]);
  const c = t.plugins.find(Rt);
  return c ? /* @__PURE__ */ r.jsxs("div", { className: e, children: [
    /* @__PURE__ */ r.jsxs(
      "button",
      {
        type: "button",
        onClick: () => o(!0),
        className: "flex items-center border border-input hover:bg-accent hover:text-accent-foreground p-4 relative h-8 justify-start rounded-lg bg-background text-sm text-muted-foreground shadow-none w-full sm:w-72",
        children: [
          /* @__PURE__ */ r.jsxs("div", { className: "flex items-center gap-2 grow", children: [
            /* @__PURE__ */ r.jsx(Kt, { size: 14 }),
            "Search"
          ] }),
          /* @__PURE__ */ r.jsx(F, { children: /* @__PURE__ */ r.jsx(Cr, {}) })
        ]
      }
    ),
    /* @__PURE__ */ r.jsx(Ce, { fallback: null, children: c.renderSearch({
      isOpen: n,
      onClose: i
    }) })
  ] }) : null;
}, Cr = () => {
  const e = wr();
  return /* @__PURE__ */ r.jsxs("kbd", { className: "absolute end-1.5 hidden h-5 select-none items-center gap-1 rounded-sm border bg-muted px-1.5 font-mono text-[11px] font-medium opacity-100 sm:flex", children: [
    e === "macOS" ? "⌘" : "Ctrl",
    "+K"
  ] });
}, ke = () => {
  const { resolvedTheme: e, setTheme: t } = je();
  return /* @__PURE__ */ r.jsx(F, { fallback: /* @__PURE__ */ r.jsx(J, { variant: "ghost", size: "icon" }), children: /* @__PURE__ */ r.jsxs(
    "button",
    {
      type: "button",
      className: "flex rounded-full border p-0.5 gap-0.5 group",
      onClick: () => t(e === "dark" ? "light" : "dark"),
      "aria-label": e === "dark" ? "Switch to light mode" : "Switch to dark mode",
      children: [
        /* @__PURE__ */ r.jsx(
          "div",
          {
            className: k(
              "border border-transparent rounded-full p-0.5 [&>svg>circle]:transition-colors [&>svg>path]:transition-transform transition-all [&>svg>path]:duration-200 [&>svg>circle]:duration-500 [&>svg>circle]:fill-transparent",
              e === "light" && "border-border bg-muted",
              e === "dark" && "group-hover:[&>svg>path]:scale-110 group-hover:[&>svg>path]:-translate-x-[1px] group-hover:[&>svg>path]:-translate-y-[1px] group-hover:rotate-[15deg] "
            ),
            children: /* @__PURE__ */ r.jsx(Ut, { size: 16 })
          }
        ),
        /* @__PURE__ */ r.jsx(
          "div",
          {
            className: k(
              "border border-transparent rounded-full p-0.5 transition-transform transform-gpu duration-500",
              e === "dark" && "border-border bg-muted [&>svg>path]:fill-white [&>svg>path]:stroke-transparent",
              e === "light" && "group-hover:rotate-[-10deg] [&>svg>path]:stroke-currentColor"
            ),
            children: /* @__PURE__ */ r.jsx(Vt, { size: 16 })
          }
        )
      ]
    }
  ) });
}, Pr = () => {
  const e = O(), { navigation: t } = e, n = z(), o = t.filter(we(n, e));
  return o.length === 0 ? /* @__PURE__ */ r.jsx("style", { children: ":root { --top-nav-height: 0px; }" }) : /* @__PURE__ */ r.jsx(Ce, { children: /* @__PURE__ */ r.jsxs("div", { className: "items-center justify-between px-8 h-(--top-nav-height) hidden lg:flex text-sm relative", children: [
    /* @__PURE__ */ r.jsx("nav", { className: "text-sm", children: /* @__PURE__ */ r.jsx("ul", { className: "flex flex-row items-center gap-8", children: o.map((i) => /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx($e, { ...i }) }, i.label + i.type)) }) }),
    /* @__PURE__ */ r.jsx(R.Target, { name: "top-navigation-side" })
  ] }) });
}, Oe = (e) => {
  switch (e.type) {
    case "doc":
      return q(e.path);
    case "link":
      return e.to;
    case "category":
      return e.link?.path ? q(e.link.path) : dt(e, (t) => {
        if (t.type !== "category")
          return Oe(t);
      }) ?? "";
    case "custom-page":
      return e.path;
  }
}, te = ({
  isActive: e,
  children: t,
  ...n
}) => /* @__PURE__ */ r.jsx(
  st,
  {
    viewTransition: !0,
    className: ({ isActive: o, isPending: i }) => {
      const c = o || e;
      return tr(
        "flex items-center gap-2 lg:py-3.5 font-medium -mb-px transition duration-150 delay-75 relative",
        c || i ? [
          "text-foreground",
          // underline with view transition animation
          "after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0",
          "after:h-0.5 after:bg-primary",
          c && "after:[view-transition-name:top-nav-underline]",
          i && "after:bg-primary/25"
        ] : "text-foreground/75 hover:text-foreground"
      );
    },
    ...n,
    children: t
  }
), $e = (e) => {
  const t = ut(), n = yt(t.topNavItem, e), o = Oe(e);
  return (
    // We don't use isActive here because it has to be inside the navigation,
    // the top nav id doesn't necessarily start with the navigation id
    /* @__PURE__ */ r.jsxs(te, { to: o, isActive: n, children: [
      e.icon && /* @__PURE__ */ r.jsx(e.icon, { size: 16, className: "align-[-0.125em]" }),
      e.label
    ] })
  );
}, Nr = () => {
  const e = O(), t = z(), { navigation: n, options: o, getProfileMenuItems: i } = e, { isAuthenticated: c, profile: s, isAuthEnabled: d } = t, [v, f] = L(!1), b = i(), y = n.filter(we(t, e));
  return /* @__PURE__ */ r.jsxs(
    Gt,
    {
      direction: o.site?.dir === "rtl" ? "left" : "right",
      open: v,
      onOpenChange: (m) => f(m),
      children: [
        /* @__PURE__ */ r.jsxs("div", { className: "flex lg:hidden justify-self-end", children: [
          /* @__PURE__ */ r.jsx(Qt, { className: "lg:hidden", children: /* @__PURE__ */ r.jsx(Wt, { size: 22 }) }),
          /* @__PURE__ */ r.jsx(Ae, {})
        ] }),
        /* @__PURE__ */ r.jsx(
          Jt,
          {
            className: "lg:hidden h-[100dvh] end-0 start-auto w-[320px] rounded-none",
            "aria-describedby": void 0,
            children: /* @__PURE__ */ r.jsxs("div", { className: "p-4 overflow-y-auto overscroll-none h-full flex flex-col justify-between", children: [
              /* @__PURE__ */ r.jsxs("div", { children: [
                /* @__PURE__ */ r.jsx(Xt, { children: /* @__PURE__ */ r.jsx(er, { children: "Navigation" }) }),
                /* @__PURE__ */ r.jsx(Re, { className: "flex p-4" }),
                /* @__PURE__ */ r.jsxs("ul", { className: "flex flex-col items-center gap-4 p-4", children: [
                  /* @__PURE__ */ r.jsx("li", { className: "empty:hidden", children: /* @__PURE__ */ r.jsx(R.Target, { name: "top-navigation-side" }) }),
                  d && /* @__PURE__ */ r.jsx(
                    F,
                    {
                      fallback: /* @__PURE__ */ r.jsx(ee, { className: "rounded-sm h-5 w-24 mr-4" }),
                      children: c ? Object.values(i()).length > 0 && /* @__PURE__ */ r.jsxs("li", { children: [
                        s?.name ? `${s.name}` : "My Account",
                        s?.email && /* @__PURE__ */ r.jsx("div", { className: "font-normal text-muted-foreground", children: s.email })
                      ] }) : /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx(
                        te,
                        {
                          to: "/signin",
                          onClick: () => f(!1),
                          children: "Login"
                        }
                      ) })
                    }
                  ),
                  y.map((m) => /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx("button", { type: "button", onClick: () => f(!1), children: /* @__PURE__ */ r.jsx($e, { ...m }) }) }, m.label)),
                  d && c && b.length > 0 && /* @__PURE__ */ r.jsx(
                    F,
                    {
                      fallback: /* @__PURE__ */ r.jsx(ee, { className: "rounded-sm h-5 w-24 mr-4" }),
                      children: b.map((m) => /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx(
                        te,
                        {
                          to: m.path ?? "",
                          onClick: () => f(!1),
                          children: m.label
                        }
                      ) }, m.label))
                    }
                  ),
                  /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx(ke, {}) })
                ] })
              ] }),
              o.site?.showPoweredBy !== !1 && /* @__PURE__ */ r.jsx(dr, { className: "grow-0 justify-center gap-1" })
            ] })
          }
        )
      ]
    }
  );
}, H = ({ item: e }) => e.children ? /* @__PURE__ */ r.jsxs(Lt, { children: [
  /* @__PURE__ */ r.jsx(zt, { children: e.label }),
  /* @__PURE__ */ r.jsx(qt, { children: /* @__PURE__ */ r.jsx(Bt, { children: e.children.map((t) => /* @__PURE__ */ r.jsx(H, { item: t }, t.label)) }) })
] }, e.label) : /* @__PURE__ */ r.jsx(re, { to: e.path ?? "", children: /* @__PURE__ */ r.jsxs(Yt, { className: "flex gap-2", children: [
  e.icon && /* @__PURE__ */ r.jsx(e.icon, { size: 16, strokeWidth: 1, absoluteStrokeWidth: !0 }),
  e.label
] }, e.label) }), Tr = Pe(function() {
  const t = z(), { isAuthenticated: n, profile: o, isAuthEnabled: i } = z(), c = O(), { site: s, plugins: d, options: v } = c, f = d.filter((l) => Ne(l)).flatMap((l) => l.getProfileMenuItems(c)).sort((l) => l.weight ?? 0), b = s?.logo ? /https?:\/\//.test(s.logo.src.light) ? s.logo.src.light : q(v.basePath, s.logo.src.light) : void 0, y = s?.logo ? /https?:\/\//.test(s.logo.src.dark) ? s.logo.src.dark : q(v.basePath, s.logo.src.dark) : void 0, m = "inset-shadow-[0_-1px_0_0_var(--border)]";
  return /* @__PURE__ */ r.jsxs(
    "header",
    {
      className: "sticky lg:top-0 z-10 bg-background/80 backdrop-blur w-full",
      "data-pagefind-ignore": "all",
      children: [
        /* @__PURE__ */ r.jsx(ur, {}),
        /* @__PURE__ */ r.jsxs("div", { className: k(m, "relative"), children: [
          /* @__PURE__ */ r.jsx(Ae, {}),
          /* @__PURE__ */ r.jsxs("div", { className: "max-w-screen-2xl mx-auto flex items-center justify-between h-(--top-header-height) px-4 lg:px-8 border-transparent", children: [
            /* @__PURE__ */ r.jsx("div", { className: "flex", children: /* @__PURE__ */ r.jsx(re, { to: s?.logo?.href ?? "/", children: /* @__PURE__ */ r.jsx("div", { className: "flex items-center gap-3.5", children: s?.logo ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
              /* @__PURE__ */ r.jsx(
                "img",
                {
                  src: b,
                  alt: s.logo.alt ?? s.title,
                  style: { width: s.logo.width },
                  className: "max-h-(--top-header-height) dark:hidden",
                  loading: "lazy"
                }
              ),
              /* @__PURE__ */ r.jsx(
                "img",
                {
                  src: y,
                  alt: s.logo.alt ?? s.title,
                  style: { width: s.logo.width },
                  className: "max-h-(--top-header-height) hidden dark:block",
                  loading: "lazy"
                }
              )
            ] }) : /* @__PURE__ */ r.jsx("span", { className: "font-semibold text-2xl", children: s?.title }) }) }) }),
            /* @__PURE__ */ r.jsx("div", { className: "absolute inset-x-0 justify-center items-center hidden lg:flex w-full pointer-events-none", children: /* @__PURE__ */ r.jsx(Re, { className: "pointer-events-auto" }) }),
            /* @__PURE__ */ r.jsxs("div", { className: "flex items-center gap-8", children: [
              /* @__PURE__ */ r.jsx(Nr, {}),
              /* @__PURE__ */ r.jsxs("div", { className: "hidden lg:flex items-center justify-self-end text-sm gap-2", children: [
                /* @__PURE__ */ r.jsx(R.Target, { name: "head-navigation-start" }),
                i && /* @__PURE__ */ r.jsx(
                  F,
                  {
                    fallback: /* @__PURE__ */ r.jsx(ee, { className: "rounded-sm h-5 w-24 mr-4" }),
                    children: n ? Object.values(f).length > 0 && /* @__PURE__ */ r.jsxs($t, { modal: !1, children: [
                      /* @__PURE__ */ r.jsx(It, { asChild: !0, children: /* @__PURE__ */ r.jsx(J, { variant: "ghost", children: o?.name ?? "My Account" }) }),
                      /* @__PURE__ */ r.jsxs(Dt, { className: "w-56", children: [
                        /* @__PURE__ */ r.jsxs(Ft, { children: [
                          o?.name ? `${o.name}` : "My Account",
                          o?.email && /* @__PURE__ */ r.jsx("div", { className: "font-normal text-muted-foreground", children: o.email })
                        ] }),
                        f.filter((l) => l.category === "top").length > 0 && /* @__PURE__ */ r.jsx(X, {}),
                        f.filter((l) => l.category === "top").map((l) => /* @__PURE__ */ r.jsx(H, { item: l }, l.label)),
                        f.filter(
                          (l) => !l.category || l.category === "middle"
                        ).length > 0 && /* @__PURE__ */ r.jsx(X, {}),
                        f.filter(
                          (l) => !l.category || l.category === "middle"
                        ).map((l) => /* @__PURE__ */ r.jsx(H, { item: l }, l.label)),
                        f.filter((l) => l.category === "bottom").length > 0 && /* @__PURE__ */ r.jsx(X, {}),
                        f.filter((l) => l.category === "bottom").map((l) => /* @__PURE__ */ r.jsx(H, { item: l }, l.label))
                      ] })
                    ] }) : /* @__PURE__ */ r.jsx(J, { variant: "ghost", onClick: () => t.login(), children: "Login" })
                  }
                ),
                /* @__PURE__ */ r.jsx(R.Target, { name: "head-navigation-end" }),
                /* @__PURE__ */ r.jsx(ke, {})
              ] })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ r.jsx("div", { className: k("hidden lg:block", m), children: /* @__PURE__ */ r.jsxs("div", { className: "max-w-screen-2xl mx-auto border-transparent relative", children: [
          /* @__PURE__ */ r.jsx(R.Target, { name: "top-navigation-before" }),
          /* @__PURE__ */ r.jsx(Pr, {}),
          /* @__PURE__ */ r.jsx(R.Target, { name: "top-navigation-after" })
        ] }) })
      ]
    }
  );
}), Ie = {
  Header: Tr
}, _r = ne(Ie), Mr = _r.Provider, Ar = () => {
  const e = Se(), t = O(), n = D(void 0);
  return $(() => {
    t.emitEvent("location", {
      from: n.current,
      to: e
    }), n.current = e;
  }, [t, e]), null;
}, Rr = ({
  children: e,
  context: t
}) => (ft({
  queryFn: async () => (await t.initialize(), !0),
  queryKey: ["zudoku-initialize", mt]
}), /* @__PURE__ */ r.jsx(ht.Provider, { value: t, children: e }));
let ye;
const De = Pe(
  ({ children: e, ...t }) => {
    const n = W(
      () => ({ ...Ie, ...t.overrides }),
      [t.overrides]
    ), o = Se(), i = W(() => ({
      ...(t.plugins ?? []).filter(kt).flatMap(
        (l) => l.getMdxComponents ? [l.getMdxComponents()] : []
      ).reduce(
        (l, g) => ({ ...l, ...g }),
        {}
      ),
      ...bt,
      ...t.mdx?.components
    }), [t.mdx?.components, t.plugins]), { stagger: c } = Nt(ue), [s, d] = L(!1), v = W(
      () => s ? { stagger: !0 } : { stagger: c },
      [c, s]
    ), f = Ee(), b = pt();
    $(() => {
      s || !f.location || d(!0);
    }, [s, f.location]), ye ??= new ir(t, b);
    const y = t.plugins?.flatMap(
      (m) => Ot(m) ? m.getHead?.({ location: o }) ?? [] : []
    ).map((m, l) => /* @__PURE__ */ r.jsx(be, { children: m }, l));
    return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      y,
      /* @__PURE__ */ r.jsx(ue.Provider, { value: v, children: /* @__PURE__ */ r.jsxs(Rr, { context: ye, children: [
        /* @__PURE__ */ r.jsx(Ar, {}),
        /* @__PURE__ */ r.jsx(jt, { slots: t.slots ?? t.UNSAFE_slotlets, children: /* @__PURE__ */ r.jsx(rt, { components: i, children: /* @__PURE__ */ r.jsx(nt, { attribute: "class", disableTransitionOnChange: !0, children: /* @__PURE__ */ r.jsx(Mr, { value: n, children: /* @__PURE__ */ r.jsx(Et, { children: e ?? /* @__PURE__ */ r.jsx(at, {}) }) }) }) }) })
      ] }) })
    ] });
  }
);
De.displayName = "ZudokoInner";
const Fe = (e) => /* @__PURE__ */ r.jsx(nr, { FallbackComponent: lr, children: /* @__PURE__ */ r.jsx(De, { ...e }) });
Fe.displayName = "Zudoku";
const Jr = be, en = lt, tn = St, rn = Ct, nn = F, on = ct, sn = re, an = Fe, cn = wt, ln = R, un = ot, dn = O, fn = z, mn = gt, hn = vt, pn = je;
export {
  on as B,
  en as C,
  nr as E,
  Tr as H,
  sn as L,
  tn as M,
  dr as P,
  rn as S,
  cn as T,
  an as Z,
  ue as a,
  Sr as b,
  Jr as c,
  nn as d,
  ln as e,
  un as f,
  fn as g,
  mn as h,
  hn as i,
  pn as j,
  dn as u
};
//# sourceMappingURL=index-CVfG8Pb4.js.map
